import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "backdrop-container h-0 top-10 left-0 overflow-hidden pt-56.25% w-full absolute mx-auto z-0 lg:h-675px" }
const _hoisted_2 = { class: "backdrop-wrapper h-0 left-0 overflow-hidden pt-56.25% absolute top-0 z-0 w-full max-w-1200px lg:h-675px lg:left-2/4 lg:transform lg:-translate-x-2/4" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "bg-hero-gradient4 bottom-0 block left-0 absolute top-0 w-full lg:h-675px lg:left-2/4 lg:transform lg:-translate-x-2/4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "backdrop-image bg-home-hero bg-home-position left-0 top-0 absolute w-full lg:h-675px",
        src: _ctx.animeBackground,
        alt: _ctx.animeBackground.value
      }, null, 8, _hoisted_3),
      _hoisted_4
    ])
  ]))
}